<template>
    <v-card flat>
        <v-card-title>
            <h4 class="subheading text-xs-left font-weight-regular section-title--color">
                Folder
            </h4>
        </v-card-title>
        <div class="px-3 py-3">
            <v-radio-group
                    :disabled="!monitorActionReady"
                    v-model="selectedFolder"
                    :mandatory="false"
                    @change="filterByFolder"
                    class="mt-0 pt-0 custom-radio-size"
                    hide-details
            >
                <v-radio
                        on-icon="far fa-envelope fa-lg"
                        off-icon="far fa-envelope fa-lg"
                        :ripple="false"
                        color="bindezcolor"
                        :value="inbox"
                        style="margin-bottom: 15px; width: 100%"
                >
                    <template slot="label">
                        <div style="display:flex; width: 100%;" class="align-center">
                            <span class="d-inline-block mr-auto body-1">Inbox</span>
                            <v-tooltip top>
                                <template slot="activator" slot-scope="{on}">
                                    <v-chip color="bindezcolor" label small text-color="#fff" v-on="on">
                                        {{commentsCount.inbox_count | abbrNumber}}
                                    </v-chip>
                                </template>
                                <span>{{commentsCount.inbox_count | formatNumber}}</span>
                            </v-tooltip>
                        </div>
                    </template>
                </v-radio>
                <v-radio
                        on-icon="far fa-trash-alt fa-lg"
                        off-icon="far fa-trash-alt fa-lg"
                        :ripple="false"
                        color="bindezcolor"
                        :value="trash"
                        style="width: 100%; padding-left: 1px; padding-top:3px; padding-bottom: 3px;"
                >
                    <template slot="label">
                        <div style="display:flex; width: 100%;" class="align-center body-1">
                            <span class="d-inline-block mr-auto">Trash</span>
                            <v-tooltip top>
                                <template slot="activator" slot-scope="{on}">
                                    <v-chip color="bindezcolor" label small text-color="#fff" v-on="on">
                                        {{commentsCount.trash_count | abbrNumber}}
                                    </v-chip>
                                </template>
                                <span>{{commentsCount.trash_count | formatNumber}}</span>
                            </v-tooltip>
                        </div>
                    </template>
                </v-radio>
            </v-radio-group>
        </div>
    </v-card>
</template>

<script>
	import {mapState, mapMutations} from 'vuex'

	export default {
		name: "FolderFilter",
		data() {
			return {
				inbox: ['positive', 'negative', 'interest', 'neutral'],
				trash: ['other'],
			}
		},
		computed: {
			...mapState('sentiment', [
				'folder'
			]),

			...mapState([
				'monitorActionReady',
                'commentsCount',
			]),

			selectedFolder: {
				get() {
					return this.folder
				},
				set(value) {
					this.setSelectedFolder(value);
				}
			},
		},

		methods: {
			...mapMutations('sentiment', [
				'setSelectedFolder',
				'setSelectedSentiment'
			]),

			filterByFolder() {
				this.$ua.trackEvent("Filter Comments", "check", "Filter Comments By Folder");
				this.setSelectedSentiment([]);
				this.$emit('filterByFolder')
			}
		}
	}
</script>

<style scoped>
.custom-radio-size >>> .v-input__control, .custom-radio-size >>> .v-label{
    width: 100%;
}
</style>
